import react from 'react';
import { featuresConfig } from '@/env-exports';

export const FeaturesContext = react.createContext(featuresConfig);

FeaturesContext.displayName = 'Features Config';
